import { render, staticRenderFns } from "./ObjectDetails.vue?vue&type=template&id=12b3c126&"
import script from "./ObjectDetails.vue?vue&type=script&lang=js&"
export * from "./ObjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports